var exports = {
  "kL": "xdbfd91f1--0f504b--container",
  "Kk": "xdbfd91f1--0f504b--icon",
  "y_": "xdbfd91f1--0f504b--remoteness",
};

module.exports = exports;
